module.exports = __webpack_public_path__ + "img/terminal-T10-P.ad87efd8.png";